export default "__VITE_ASSET__9KPltvCT__"